import { FilterModel, GridOptions } from 'ag-grid-community';
import type { DataGridComponent } from '@sensika/ag-grid-kit';

/**
 * Column filters a deep link brings along (a dashboard drill-down, WAP-1762):
 * seeded as ag-grid `initialState` so the very first request carries them, and
 * re-merged once over the opening preset, which replaces the whole filter model
 * right before the datasource attaches (bind `restore` to the grid's
 * `onApplyExtraViewPresetSettings`). A preset the user picks later replaces
 * them like any other filter.
 */
export class DrillFilters {
  private pending: FilterModel;

  constructor(filters: FilterModel = {}) {
    this.pending = filters;
  }

  get any(): boolean {
    return Object.keys(this.pending).length > 0;
  }

  /** The `initialState` slice for `gridOptionsOverrides`; empty when there is nothing to seed. */
  gridOptions(): Partial<GridOptions> {
    return this.any
      ? { initialState: { filter: { filterModel: this.pending } } }
      : {};
  }

  restore(grid: DataGridComponent | undefined): void {
    const api = grid?.api;
    if (api && this.any) {
      api.setFilterModel({ ...api.getFilterModel(), ...this.pending });
      this.pending = {};
    }
  }
}
